import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'app-mirive-auction',
  templateUrl: './mirive-auction.component.html',
  styleUrls: ['./mirive-auction.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MiriveAuctionComponent {
  @Input() lang = 'ru';
}
